import { Injectable } from '@angular/core';
import { AcademicYearTerm } from '@exclusionmodule/models';
import { dateFormatEnum } from './date-constants';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  ddmmyyyyRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
  ddmmyyyyhhmmRegex =
    /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4} (20|21|22|23|[0-1]\d):[0-5]\d$/;

  // Check whether the date manually entered is in valid date foramt ie. DD/MM/YYYY
  IsValidDateFormat(inputDate: string, format: dateFormatEnum): boolean {
    let regEx: RegExp;
    switch (format) {
      case dateFormatEnum.ddmmyyyy: {
        regEx = this.ddmmyyyyRegex;
        break;
      }
      case dateFormatEnum.ddmmyyyyhhmm: {
        regEx = this.ddmmyyyyhhmmRegex;
        break;
      }
    }
    return regEx.test(inputDate);
  }

  // Create date object from the date string
  GetDateFromString(inputDate: string, format: dateFormatEnum): Date | null {
    let year: number;
    let month: number;
    let date: number;
    let hours = 0;
    let minutes = 0;
    const seconds = 0;
    const miliseconds = 0;
    if (
      inputDate === null ||
      inputDate === undefined ||
      inputDate.trim() === ''
    ) {
      return null;
    }

    if (format === dateFormatEnum.ddmmyyyy) {
      const dateParts = inputDate.split('/');
      year = parseInt(dateParts[2]);
      month = parseInt(dateParts[1]) - 1;
      date = parseInt(dateParts[0]);
    } else if (format === dateFormatEnum.ddmmyyyyhhmm) {
      const dateParts = inputDate.split(' ');
      const dtPart = dateParts[0].split('/');
      year = parseInt(dtPart[2]);
      month = parseInt(dtPart[1]) - 1;
      date = parseInt(dtPart[0]);
      const timePart = dateParts[1].split(':');
      hours = parseInt(timePart[0]);
      minutes = parseInt(timePart[1]);
    }
    return new Date(year, month, date, hours, minutes, seconds, miliseconds);
  }

  // Check whether the date is non school date
  IsDateExistInDatesCollection(dateToSearch: Date, dateCollection: Date[]) {
    if (dateToSearch) {
      return dateCollection.some((x) => x.getTime() === dateToSearch.getTime());
    }
    return false;
  }

  // Get Academic Year End date from Academic Year Terms collection
  GetAcademicYearEndDateFromAcademicYearsTerms(
    date: Date,
    academicyearterm: AcademicYearTerm[]
  ): Date {
    const exclusionAcademicYear = academicyearterm?.find(
      (x) =>
        new Date(x.startDate).getTime() <= new Date(date).getTime() &&
        new Date(x.endDate).getTime() >= new Date(date).getTime()
    )?.academicYear;

    const maxAcademicYearDate = new Date(
      Math.max.apply(
        null,
        academicyearterm
          .filter((x) => x.academicYear === exclusionAcademicYear)
          .map((x) => new Date(x.endDate))
      )
    );
    return maxAcademicYearDate;
  }

  // Check if the date is not entered
  checkEmptyDate(inputDate: string) {
    if (inputDate.replace(/\s/g, '') === '') {
      return false;
    }
    return true;
  }
}
